module.exports = __webpack_public_path__ + "img/invite_award_icon.52812933.png";